<template>
    <div class="container">
      <el-page-header class="page-header" @back="goBack" :content="title"></el-page-header>
      <div class="content">
        <p v-for="item in results">{{item}}</p>
      </div>
    </div>
</template>

<script>
export default {
    data () {
        return {
            results:[],
            title:'',
            visitRecordId:''
        }
    },
    created(){
      this.visitRecordId = this.$route.query.visitRecordId
      var serviceInfo = JSON.parse(sessionStorage.getItem('serviceInfo'))
      var patientId = serviceInfo.patientId
      var useDate = serviceInfo.useDate
      var useDays = serviceInfo.useDays
      var serviceIndex = serviceInfo.serviceIndex

      var params = {
        patientId:patientId
      }
      console.log("created")
      // console.log("serviceIndex:"+serviceIndex)
      var url = ''
      if(serviceIndex == 1){
        document.title = "健康预测结果"
        this.title = '健康预测'
        url='/api/health/v1/disease'
        params.toPredictDay = useDate.replace(/-/g,'')
        params.predictDays = useDays
      }else if(serviceIndex == 2){
        document.title = "茶饮结果"
        this.title = '茶饮'
        url='/api/health/v1/dietTherapy'
        params.recordType = 'T'
      }else if(serviceIndex == 3){
        document.title = "经络调理结果"
        this.title = '经络调理'
        url='/api/health/v1/massage'
        params.recordType = 'M'
      }else if(serviceIndex == 4){
        document.title = "针灸结果"
        this.title = '针灸'
        url='/api/health/v1/acupuncture'
        params.recordType = 'A'
      }else if(serviceIndex == 5){
        document.title = "压片糖果结果"
        this.title = '压片糖果'
        url='/api/health/v1/medicine'
        params.recordType = 'C'
      }
      if(serviceIndex != 1){
        params.toDoDay = useDate
        if(!this.utils.isEmptyStr(useDays)){
          params.takeDays = useDays
        }
      }
      if(this.visitRecordId){
        url = 'api/health/v2/rela/record'
        params.relaVisitRecordId = this.visitRecordId
      }
      console.log(url)
      this.wjtHttp.post(this,url,params,false,(res)=>{
              var data = res.data
              if(data.code == 200){
                  var rs = data.data.split('\n')
                  var newRS = []
                  rs.forEach((val,index)=>{
                    if(val.length != 0){
                      newRS.push(val.replace(/ /g,''))
                    }
                  })
                  this.results = newRS
              }else{
                  this.$message({
                      message:(data.msg&&data.msg.length > 0)?data.msg:'搜索异常，请联系管理员',
                      type:'error'
                  })
              }
          },(err)=>{
              console.log(err)
          })
    },
    methods:{
      goBack(){
        this.$router.go(-1)
      }
    }
}
</script>

<style scoped>
.container{
    width: 1160px;
    margin: auto auto;
    height: auto;
}
.content{
  width: 1100px;
  height: auto;
  background-image: url('../../static/image/service_background.png');
  background-size: 100% 100%;
  padding: 56px 35px;
  margin: 40px 30px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  overflow: auto;
}
.content>p{
  text-align: left;
  line-height: 26px;
  font-size: 18px;
  margin: 8px 0px;
  color: #126FB3;
}
.page-header{
    width: 1160px;
    margin-top: 30px;
    color: #333333;
    font-size: 20px;
}
.page-header >>> div{
    color:#333333;
    font-size: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/serviceResult.vue